import { RegularMasonryGrid } from "@masonry-grid/solid-js";
import { type Accessor, For, Show } from "solid-js";
import type { ListBoardClipsResponses } from "@/client";
import { useBoardDetails } from "../BoardDetailsContext";
import { Clip } from "./Clip";

export const CLIPS_MASONRY_FRAME_WIDTH = 200;
export const CLIPS_MASONRY_GAP = "0.5rem";

type Props = {
	clips: Accessor<ListBoardClipsResponses[200] | undefined>;
};

export const ClipsGrid = (props: Props) => {
	const boardDetails = useBoardDetails();
	const clips = () => props.clips() ?? [];
	const clipIdsKey = () => clips().map((clip) => clip.id).join("\0");

	return (
		<div class="boards-details__clips-scroll">
			<Show when={clipIdsKey()} keyed>
				<RegularMasonryGrid
					class="clips-grid"
					frameWidth={CLIPS_MASONRY_FRAME_WIDTH}
					gap={CLIPS_MASONRY_GAP}
				>
					<For each={clips()}>
						{(clip, index) => (
							<Clip
								clip={clip}
								onPlayVideo={() => boardDetails.playVideo(clip, index())}
							/>
						)}
					</For>
				</RegularMasonryGrid>
			</Show>
		</div>
	);
};
